var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',_vm._b({attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"blur":_vm.handleBlur},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'a-select',_vm.$attrs,false),_vm._l((_vm.list),function(item){return _c('a-select-option',{key:item},[_vm._v(" "+_vm._s(item)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }